import { create } from 'zustand';

export const useUIStore = create(set => ({
  mobileSidebarOpen: false,
  setMobileSidebarOpen: v => set({ mobileSidebarOpen: v }),
}));
